module.exports = __webpack_public_path__ + "img/7.f3fb2927.png";